<template lang="html" functional>
  <div class="wrapper">
    <div class="spinner relative">
      <img
        src="@/assets/images/coredata-ring.png"
        class="spinner__ring absolute inset-0"
      />
      <img
        src="@/assets/images/coredata-blad.svg"
        class="spinner__blad absolute inset-0"
      />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.spinner {
  position: relative;
  height: 144px;
  width: 144px;
}

.spinner__ring {
  height: 100%;
  width: 100%;
  animation: spinner 1s linear infinite;
  transform-origin: 52% 52%;
}

.spinner__blad {
  height: 100%;
  width: 100%;
  animation: heart 1.5s ease-in-out infinite;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes heart {
  0% {
    transform: scale(0.4);
  }

  25% {
    transform: scale(0.44);
  }

  30% {
    transform: scale(0.62);
  }

  45% {
    transform: scale(0.43);
  }

  50% {
    transform: scale(0.6);
  }

  65% {
    transform: scale(0.42);
  }

  100% {
    transform: scale(0.4);
  }
}
</style>
